export default {
  beforeRouteLeave(to, from, next) {
    if (this.anyDirty) {
      this.showConfirm('You have unsaved data. Do you want to abandon these changes?')
        .then(next, next);
    } else {
      next();
    }
  },
  methods: {
    checkDirtyModalForm(e, modalFormDirty, confirm) {
      if (modalFormDirty && e.trigger !== 'bypass-dirty-check') {
        e.preventDefault();
        this.showConfirm('You have unsaved data. Do you want to abandon these changes?')
          .then(() => {
            e.vueTarget.hide('bypass-dirty-check');
            if (confirm) {
              confirm();
            }
          });
      }
    },
  },
};
